<div class="modal-header">
  <span class="modal-title">{{currentSlide?.file.name}}</span>
  <div class="controls">
    <div class="page-indicator">{{(guideList?.length>0)?activeSlideIndex +1:0 }} of {{guideList?.length}}</div>
    <div class="page-control">
      <button (click)="prevSlide()">&lt;</button>
      <button (click)="nextSlide()">&gt;</button>
    </div>
    <button type="button" class="icon-btn-close" (click)="bsModalRef.hide()">
    </button>
  </div>

</div>
<div class="modal-body">
  <carousel *ngIf="guideList.length" 
    [interval]="false" [noWrap]="true" [(activeSlide)]="activeSlideIndex"
    (activeSlideChange)="onSlideChange($event)">
    <slide *ngFor="let item of guideList" [@fadeIn]="item.status">
 
      <app-viewer-content [hide]="true" [file]="item.file"></app-viewer-content>
     
    </slide>
   
  </carousel>
    <div *ngIf="guideList.length">
     <i class="carousel-control-prev icon icon-arrow-back-breadcrumb"(click)="prevSlide()"></i>
    <i class="carousel-control-next icon icon-arrow-fwd" (click)="nextSlide()">
    </i>
    </div>
</div>
